export default "__VITE_ASSET__a36ae7e6__"